<template>
  <div class="register-container">
    <!-- Mask Decoration -->
    <div class="mask-decoration"></div>

    <!-- Main Layout -->
    <div class="container-fluid min-vh-100 d-flex p-0">
      <div class="row w-100 m-0 g-0">
        <!-- Left Side: Image -->
        <div class="col-lg-5 d-none d-lg-block p-4 d-flex align-items-center">
          <div class="register-image-wrapper h-100 w-100">
            <img
              src="../../../public/img/register_image.jpg"
              alt="Register Image"
              class="register-image"
            />
          </div>
        </div>

        <!-- Right Side: Form -->
        <div class="col-12 col-lg-7 d-flex flex-column justify-content-center align-items-center position-relative py-3 overflow-y-auto">
          <div class="register-content-wrapper w-100">
            <!-- STEP 1: RNE Validation with Email and Password -->
            <div v-if="currentStep === 1">
              <!-- Logos Centered -->
              <div class="d-flex justify-content-center align-items-center mb-2 gap-3">
                <div class="logo-box">
                  <img
                    src="../../../public/img/ccd_escudo.png"
                    class="escudo-logo escudo-ccd"
                    alt="CCD Logo"
                  />
                </div>
                <div class="logo-divider"></div>
                <div class="logo-box">
                  <img
                    src="../../../public/img/fvf_escudo.png"
                    class="escudo-logo escudo-fvf"
                    alt="FVF Logo"
                  />
                </div>
              </div>

              <div class="text-center mb-3">
                <h1 class="font-weight-bolder text-dark mb-1 rne-title">ACCESO CON RNE</h1>
                <p class="text-dark mb-0 subtitle-text">
                  Por favor, ingresa tus credenciales del<br />
                  RNE (Registro Nacional de Entrenadores).
                </p>
              </div>

              <div class="form-container-register mx-auto">
                <form role="form" @submit.prevent="validateStep1">
                  <div class="mb-3">
                    <label class="form-label">Correo usado en Registro Nacional de Entrenadores</label>
                    <input
                      type="email"
                      class="form-control"
                      placeholder="Ingresa tu correo"
                      v-model.trim="form_save.email"
                      name="email"
                      autocomplete="new-password"
                    />
                  </div>

                  <div class="mb-3">
                    <label class="form-label">Contraseña</label>
                    <div class="password-input-container">
                      <input
                        :type="showPassword ? 'text' : 'password'"
                        class="form-control"
                        placeholder="Ingresa tu contraseña"
                        v-model="form_save.password"
                        name="password"
                        autocomplete="new-password"
                      />
                      <button
                        type="button"
                        class="password-toggle-btn"
                        @click="togglePassword"
                        :title="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                      >
                        <v-icon
                          :name="showPassword ? 'eye' : 'eye-slash'"
                          :fill="showPassword ? '#333' : '#b49b57'"
                        ></v-icon>
                      </button>
                    </div>
                  </div>

                  <div class="text-center mt-4">
                    <p class="text-muted mb-3 px-2 info-note-text" style="line-height: 1.4;">
                      Con tus credenciales de RNE, procederás a crear tu cuenta en el Centro de Capacitación y Desarrollo, de esta manera con el mismo correo podrás acceder a ambas plataformas.
                    </p>
                    <button
                      type="submit"
                      class="btn golden-btn w-100"
                      :disabled="isLoading"
                    >
                      <span v-if="!isLoading">Validar</span>
                      <span v-else>Validando...</span>
                    </button>
                  </div>

                  <div class="text-center mt-3">
                    <p class="text-dark mb-0 subtitle-text">
                      <a href="login" style="color: #BC9A52" class="font-weight-bold text-decoration-underline ml-1 back-to-login-link">Volver al inicio de sesión</a>
                    </p>
                  </div>
                </form>
              </div>
            </div>

            <!-- STEP 2: Complete Registration -->
            <div v-if="currentStep === 2">
              <!-- Logos Left Aligned -->
              <div class="d-flex justify-content-start align-items-center mb-2 gap-3">
                <div class="logo-box">
                  <img
                    src="../../../public/img/ccd_escudo.png"
                    class="escudo-logo escudo-ccd"
                    alt="CCD Logo"
                  />
                </div>
                <div class="logo-divider"></div>
                <div class="logo-box">
                  <img
                    src="../../../public/img/fvf_escudo.png"
                    class="escudo-logo escudo-fvf"
                    alt="FVF Logo"
                  />
                </div>
              </div>

              <div class="text-start mb-3">
                <h1 class="font-weight-bolder text-dark mb-1">REGISTRO</h1>
                <p class="text-dark mb-0 subtitle-text">
                  Completa los campos para crear tu cuenta en el panel del Centro de Capacitación y Desarrollo de la FVF
                </p>
              </div>

              <div class="form-container-register mx-auto">
                <form role="form" @submit.prevent="saveUser">
                  <div class="row g-3">
                    <div class="col-md-6">
                      <div class="mb-2">
                        <label class="form-label">Nombre</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Ingresa tu nombre"
                          v-model="form_save.first_name"
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="mb-2">
                        <label class="form-label">Apellido</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Ingresa tu apellido"
                          v-model="form_save.last_name"
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="mb-2">
                        <label class="form-label">Correo</label>
                        <input
                          type="email"
                          class="form-control"
                          placeholder="Ingresa tu correo"
                          v-model.trim="form_save.email"
                          disabled
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="mb-2">
                        <label class="form-label">Teléfono</label>
                        <input
                          type="number"
                          class="form-control"
                          placeholder="Ingresa tu teléfono"
                          v-model="form_save.phone"
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="mb-2">
                        <label class="form-label">Cédula</label>
                        <input
                          type="number"
                          class="form-control"
                          placeholder="Ingresa tu cédula"
                          v-model="form_save.dni"
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="mb-2">
                        <label class="form-label">País</label>
                        <multiselect
                          v-model="form_save.id_country"
                          label="name"
                          :options="sortedCountryTmp"
                          selectLabel="Click/enter para elegir"
                          selectedLabel="Seleccionado"
                          deselectLabel="Click/Enter para remover"
                          placeholder="Selecciona tu país"
                          @select="onCountryChange"
                        >
                        </multiselect>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="mb-2">
                        <label class="form-label">Estado</label>
                        <multiselect
                          v-model="form_save.id_state"
                          label="name"
                          :options="StateTmp"
                          selectLabel="Click/enter para elegir"
                          selectedLabel="Seleccionado"
                          deselectLabel="Click/Enter para remover"
                          placeholder="Selecciona tu estado"
                          :disabled="!form_save.id_country"
                          @select="onStateChange"
                        >
                        </multiselect>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="mb-2">
                        <label class="form-label">Ciudad</label>
                         <multiselect
                          v-model="form_save.id_city"
                          label="name"
                          :options="cityTmp"
                          selectLabel="Click/enter para elegir"
                          selectedLabel="Seleccionado"
                          deselectLabel="Click/Enter para remover"
                          placeholder="Selecciona tu ciudad"
                          :disabled="!form_save.id_state"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div>

                  <div class="text-end mt-4">
                    <button
                      type="submit"
                      class="btn golden-btn px-5"
                      style="background: #541A32 !important; border-radius: 30px; color: #fff !important;"
                    >
                      <span>Crear cuenta</span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
            
            <!-- Footer Text -->
            <div class="text-center mt-4">
              <p class="footer-text text-sm mb-0">
                &copy; 2025 FVF / CCD By <a href="https://ticz.io/" target="_blank" rel="noopener noreferrer" class="ticz-link">TICZ</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import LayoutFooter from "./Layouts/Footer";
import { mapActions } from "vuex";
import Multiselect from "vue-multiselect";
import EmailValidator from "email-validator";

// Add the missing CSS styles for the Multiselect component
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  name: "register-rne",
  components: {
    Multiselect,
    LayoutFooter,
  },
  data() {
    return {
      currentStep: 1,
      isLoading: false,
      showPassword: false,
      form_save: {
        dni: "",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        id_country: "",
        id_state: "",
        id_city: "",
        id_type_user: "",
        id_rne: "",
        rne_password: "",
      },

      TypeUserTmp: [
        { id: 1, name: "Entrenador" },
        { id: 2, name: "Jugador retirado" },
        { id: 3, name: "Entrenador y Jugador retirado" },
        { id: 0, name: "Ninguno de los anteriores" },
      ],
      
      CountryTmp: [],
      StateTmp: [],
      cityTmp: [],
    };
  },
  mounted() {
    this.loadCountry();
  },
  computed: {
    sortedCountryTmp() {
      return this.CountryTmp.sort((a, b) => a.name.localeCompare(b.name));
    },

  },
  methods: {
    ...mapActions(["login", "login_rne", "getData", "createData", "recoverData", "getRegisterData"]),



    validateStep1() {
      // Validate email format
      if (!this.form_save.email || !EmailValidator.validate(this.form_save.email)) {
        Swal.fire({
          title: "Email inválido",
          text: "Debes escribir un email válido para poder continuar",
          icon: "warning",
        });
        return;
      }

      // Validate password
      if (!this.form_save.password) {
        Swal.fire({
          title: "Contraseña requerida",
          text: "Debes ingresar tu contraseña para continuar",
          icon: "warning",
        });
        return;
      }

      // Call login_rne API
      this.isLoading = true;
      const loginData = {
        email: this.form_save.email,
        password: this.form_save.password,
      };

      this.login_rne(loginData)
        .then((response) => {
          this.isLoading = false;
          
          // Usuario ya registrado - tiene token, redirigir al overview
          if (response.tokentap) {
            this.$router.push("/overview");
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
            Toast.fire({
              icon: "success",
              title: "¡Bienvenido!",
            });
            return;
          }
          
          // Fallback para código 200 con is_rne (compatibilidad)
          if (response.code === 200 && response.data && response.data.is_rne === 1) {
            this.$router.push("/overview");
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
            Toast.fire({
              icon: "success",
              title: "¡Bienvenido!",
            });
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
          
          // Usuario nuevo - status FIRSTTIME, necesita completar registro
          if (error.status === "FIRSTTIME" && error.code === 202) {
            const rneData = error.data;
            
            // Autocompletar datos del formulario con la info del RNE
            this.form_save.rne_password = loginData.password;
            this.form_save.id_rne = rneData.rne_id || "";
            this.form_save.email = rneData.email || this.form_save.email;
            this.form_save.dni = rneData.dni || "";
            this.form_save.phone = rneData.phone || "";
            
            // Separar full_name en first_name y last_name
            if (rneData.full_name) {
              const nameParts = rneData.full_name.trim().split(" ");
              if (nameParts.length >= 2) {
                this.form_save.first_name = nameParts[0];
                this.form_save.last_name = nameParts.slice(1).join(" ");
              } else {
                this.form_save.first_name = rneData.full_name;
                this.form_save.last_name = "";
              }
            }
            
            // Buscar y asignar el país
            if (rneData.id_country && this.CountryTmp.length > 0) {
              const country = this.CountryTmp.find(c => c.id === rneData.id_country);
              if (country) {
                this.form_save.id_country = country;
                this.loadState();
                
                if (rneData.id_state) {
                  setTimeout(() => {
                    const state = this.StateTmp.find(s => s.id === rneData.id_state);
                    if (state) {
                      this.form_save.id_state = state;
                    }
                  }, 500);
                }
              }
            }
            
            // Avanzar al step 2
            this.currentStep = 2;
            Swal.fire({
              title: "¡Validación exitosa!",
              text: "Completa los datos para finalizar tu registro",
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            });
            return;
          }
          
          if (error.code === 401) {
            Swal.fire({
              title: "Contraseña incorrecta",
              text: "La contraseña ingresada no es válida para este usuario",
              icon: "warning",
            });
          } else if (error.code === 404) {
            Swal.fire({
              title: "Credenciales inválidas",
              text: "No hay ningún usuario registrado con la dirección de correo electrónico ingresada en el RNE",
              icon: "warning",
            });
          } else if (error.code === 402) {
            Swal.fire({
              title: "Credenciales inválidas",
              text: "La contraseña ingresada no es correcta",
              icon: "warning",
            });
          } else {
            Swal.fire({
              title: "Error",
              text: error.message || "Ocurrió un error al validar tus credenciales",
              icon: "error",
            });
          }
        });
    },

    mailValidator() {
      let validate = EmailValidator.validate(this.form_save.email);
      if (!validate) {
        Swal.fire({
          title: "Email inválido",
          text: "Debes escribir un email válido para poder continuar",
          icon: "warning",
        });
      }
    },

    saveUser() {
      // Validaciones de campos obligatorios
      let missingFields = [];
      if (!this.form_save.first_name) missingFields.push("Nombre");
      if (!this.form_save.last_name) missingFields.push("Apellido");
      if (!this.form_save.dni) missingFields.push("Cédula");
      if (!this.form_save.phone) missingFields.push("Teléfono");
      if (!this.form_save.id_country) missingFields.push("País");
      if (!this.form_save.id_state) missingFields.push("Estado");

      if (missingFields.length > 0) {
        Swal.fire({
          title: "Campos incompletos",
          html: `Por favor completa los siguientes campos obligatorios:<br><br><ul class="text-start">${missingFields.map(f => `<li>${f}</li>`).join('')}</ul>`,
          icon: "warning",
          confirmButtonColor: "#B49B57",
        });
        return;
      }

      this.mailValidator();
      if (
        (this.form_save.id_type_user.id == 1 && !this.form_save.id_rne) ||
        (this.form_save.id_type_user.id == 3 && !this.form_save.id_rne)
      ) {
        Swal.fire({
          title: "Ingrese su ID de entrenador",
          text: "Si es entrenador debe ingresar su ID de entrenador.",
          icon: "warning",
          showConfirmButton: true,
          confirmButtonColor: "#B49B57",
        });
        } else {
          Swal.fire({
            title: "Registro de usuario",
          text: "¿Estás seguro de realizar el registro?",
          icon: "question",
          reverseButtons: true,
          showCancelButton: true,
          confirmButtonColor: "#B49B57",
          cancelButtonColor: "#abb2ba",
          cancelButtonText: "Cancelar",
          confirmButtonText: "Si, registrar",
        }).then((result) => {
          if (result.value) {
            this.deleting = true;

            let form = {
              url: "auth/register_ccd",
              data: {
                first_name: this.form_save.first_name,
                last_name: this.form_save.last_name,
                email: this.form_save.email,
                phone: this.form_save.phone,
                dni: this.form_save.dni,
                id_country: this.form_save.id_country.id,
                id_state: this.form_save.id_state.id,
                id_type_user: this.form_save.id_type_user.id,
                id_rne: this.form_save.id_rne,
                password: this.form_save.rne_password,
                password_confirmation: this.form_save.rne_password,
              },
            };

            this.recoverData(form)
              .then((response) => {
                if (response.code === 200 || response.code === 201) {
                  this.deleting = false;
                  Swal.fire({
                    title: "¡Registro completado!",
                    text: "Tu cuenta ha sido creada exitosamente. Por favor inicia sesión.",
                    icon: "success",
                    confirmButtonText: "Ir al Login",
                    confirmButtonColor: "#B49B57",
                  }).then((result) => {
                    this.$router.push("/login");
                  });
                }

                if (response.code === 409) {
                  this.deleting = false;
                  Swal.fire({
                    title: "Ya existe un usuario con estos datos",
                    icon: "warning",
                    sshowConfirmButton: true,
                    showLoaderOnConfirm: true,
                  });
                }

                if (response.code === 410) {
                  this.deleting = false;
                  Swal.fire({
                    title: "Ya existe un usuario con este RNE",
                    icon: "warning",
                    sshowConfirmButton: true,
                    showLoaderOnConfirm: true,
                  });
                }

                if (response.code === 408) {
                  this.deleting = false;
                  Swal.fire({
                    title: "Ya existe un usuario con este correo",
                    icon: "warning",
                    sshowConfirmButton: true,
                    showLoaderOnConfirm: true,
                  });
                }

                if (response.code === 403) {
                  this.deleting = false;
                  Swal.fire({
                    title: "Ya existe otro usuario con este teléfono",
                    icon: "warning",
                    showConfirmButton: true,
                    showLoaderOnConfirm: true,
                  });
                }
              })
              .catch((error) => {
                console.log(error);
                this.deleting = false;
                alert("Ocurrió un error, intente más tarde");
              });
          }
        });
      }
    },

    loadCountry() {
      let form = {
        url: "master/country/all",
        params: {
          order_value: "asc",
          order_by: "name",
          active: 1,
          lite: 1
        },
      };

      this.isBusy = true;
      this.getRegisterData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.CountryTmp = response.data;
            // Preset Venezuela by name (agnostic of ID)
            const venezuela = this.CountryTmp.find((c) => c.name.toLowerCase() === "venezuela");
            if (venezuela) {
              this.form_save.id_country = venezuela;
              this.loadState();
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    onCountryChange(val) {
      this.form_save.id_country = val;
      this.loadState();
    },

    onStateChange(val) {
      this.form_save.id_state = val;
      this.loadCity();
    },

    loadState() {
      // Reset state and city when country changes
      this.form_save.id_state = "";
      this.form_save.id_city = "";
      this.StateTmp = [];
      this.cityTmp = [];

      if (!this.form_save.id_country) return;

      let form = {
        url: "master/state/all",
        params: {
          order_value: "asc",
          order_by: "name",
          active: 1,
          lite: 1,
          id_country: this.form_save.id_country.id,
        },
      };

      this.isBusy = true;
      this.getRegisterData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.StateTmp = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadCity() {
      // Reset city when state changes
      this.form_save.id_city = "";
      this.cityTmp = [];

      if (!this.form_save.id_state) return;

      let form = {
        url: "master/city/all",
        params: {
          order_value: "asc",
          order_by: "name",
          active: 1,
          lite: 1,
          id_state: this.form_save.id_state.id,
        },
      };

      this.isBusy = true;
      this.getRegisterData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.cityTmp = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

  },
};
</script>
<style scoped>
/* Register container */
.register-container {
  position: relative;
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  background-color: white;
  z-index: 1;
}

/* Mask Decoration */
.mask-decoration {
  position: absolute;
  top: 0;
  right: -370px;
  width: 70%;
  height: 100%;
  background-image: url("../../../public/img/ccd_mask.png");
  background-position: center right;
  background-repeat: no-repeat;
  background-size: contain;
  z-index: 99999;
  pointer-events: none;
  filter: brightness(0.5) opacity(0.3);
}

/* Left Side Image */
.register-image-wrapper {
  border-radius: 30px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  max-height: 92vh;
  width: 100%;
  position: relative;
  z-index: 10;
}

.register-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Content Wrapper */
.register-content-wrapper {
  max-width: 900px;
  width: 90%;
  z-index: 10;
  position: relative;
}

/* Logos */
.logo-box {
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.escudo-logo {
  object-fit: contain;
  filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.1));
}

.escudo-ccd {
  height: 69px;
  width: auto;
}

.escudo-fvf {
  height: 70px;
  width: auto;
}

.logo-divider {
  width: 2px;
  height: 70px;
  background-color: rgba(0, 0, 0, 0.2);
}

/* Form Container */
.form-container-register {
  width: 100%;
  max-width: 400px;
}

/* Form controls */
.form-control {
  background: white !important;
  border-radius: 30px !important;
  border: 1px solid #ddd;
  padding: 8px 15px;
  height: 40px;
  color: #333 !important;
  font-size: 0.85rem;
}

.form-control:focus {
  background: white !important;
  border-color: #b49b57;
  box-shadow: 0 0 0 3px rgba(180, 155, 87, 0.15);
  color: #333;
}

.form-control::placeholder {
  color: #999;
}

label {
  font-weight: 500;
  font-size: 0.85rem;
  margin-bottom: 4px;
  color: #333;
}

/* Golden button */
.golden-btn {
  background: #b49b57;
  color: white;
  border-radius: 30px !important;
  padding: 10px 18px;
  font-weight: 700;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 10px rgba(180, 155, 87, 0.3) !important;
  transition: all 0.3s ease;
  height: 45px;
  font-size: 1rem;
  border: none;
}

.golden-btn:hover {
  background: #cbb16a;
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(180, 155, 87, 0.4) !important;
}

.golden-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none !important;
}

/* Password toggle */
.password-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.password-toggle-btn {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 5px;
  z-index: 10;
}

.password-input-container .form-control {
  padding-right: 50px;
}

/* Footer text */
.footer-text {
  color: rgba(156, 156, 156, 1) !important;
}

.rne-title {
  font-size: 1.25rem;
}

.subtitle-text {
  font-size: 0.85rem;
}

.info-note-text {
  font-size: 0.85rem;
}

.back-to-login-link {
  font-size: 0.95rem;
}

/* Responsive Design */
@media (max-width: 991px) {
  .register-content-wrapper {
    max-width: 700px;
    padding: 15px;
  }
  
  .mask-decoration {
    width: 100%;
    opacity: 0.05;
    right: -200px;
  }
}

@media (max-width: 768px) {
  .logo-box {
    width: 50px;
    height: 50px;
  }
  
  .escudo-ccd {
    height: 40px;
  }
  
  .escudo-fvf {
    height: 55px;
  }
  
  .logo-divider {
    height: 55px;
  }
  
  .register-content-wrapper {
    width: 95%;
    padding: 10px;
  }
  
  .form-control {
    height: 46px;
    font-size: 1.1rem;
    padding: 8px 15px;
  }
  
  .golden-btn {
    height: 48px;
    font-size: 1.2rem;
  }
  
  h1 {
    font-size: 1.7rem !important;
  }
  
  .text-center p, .subtitle-text {
    font-size: 1.15rem !important;
  }

  .info-note-text {
    font-size: 1rem !important;
  }

  .back-to-login-link {
    font-size: 1.1rem !important;
  }
  
  label {
    font-size: 1.1rem;
    margin-bottom: 5px;
  }
  
  .form-container-register {
    max-width: 100%;
  }
}

@media (max-width: 576px) {
  .logo-box {
    width: 45px;
    height: 45px;
  }
  
  .escudo-ccd {
    height: 35px;
  }
  
  .escudo-fvf {
    height: 48px;
  }
  
  .logo-divider {
    height: 48px;
  }
  
  h1 {
    font-size: 1.6rem !important;
  }
  
  .text-center p, .subtitle-text {
    font-size: 1.1rem !important;
  }

  .info-note-text {
    font-size: 0.95rem !important;
  }

  .back-to-login-link {
    font-size: 1.05rem !important;
  }
  
  .form-control {
    height: 44px;
    font-size: 1.05rem;
    padding: 8px 12px;
  }
  
  .golden-btn {
    height: 46px;
    font-size: 1.15rem;
    padding: 8px 15px;
  }
  
  label {
    font-size: 1.05rem;
    margin-bottom: 4px;
  }
  
  .register-content-wrapper {
    padding: 8px;
  }
}

/* Altura específica para móviles */
@media (max-height: 700px) {
  .logo-box {
    width: 40px;
    height: 40px;
  }
  
  .escudo-ccd {
    height: 39px;
  }
  
  .escudo-fvf {
    height: 42px;
  }
  
  .logo-divider {
    height: 42px;
  }
  
  h1 {
    font-size: 1.35rem !important;
    margin-bottom: 0.25rem !important;
  }
  
  .text-center p, .subtitle-text {
    font-size: 0.95rem !important;
  }

  .info-note-text {
    font-size: 0.85rem !important;
  }

  .back-to-login-link {
    font-size: 0.95rem !important;
  }
  
  .form-control {
    height: 40px;
    font-size: 0.95rem;
  }
  
  .golden-btn {
    height: 42px;
    font-size: 1rem;
  }
  
  label {
    font-size: 0.95rem;
    margin-bottom: 2px;
  }
}
</style>
<style>
/* Global styles for multiselect and other components */
body {
  font-family: "Jost" !important;
}

.multiselect__tags {
  border-radius: 30px !important;
  border: 1px solid #ddd !important;
  min-height: 40px !important;
  padding: 6px 40px 0 8px !important;
}

.multiselect__content-wrapper {
  border-radius: 15px !important;
  position: absolute;
  z-index: 1000;
}

.multiselect__option--highlight {
  background: #b49b57 !important;
  background-color: #b49b57 !important;
}

.multiselect__option--highlight:after {
  background: #b49b57 !important;
}

.multiselect__option--selected.multiselect__option--highlight {
  background: rgb(53, 16, 32) !important;
}

.multiselect__option--selected.multiselect__option--highlight:after {
  background: rgb(53, 16, 32) !important;
}

/* SweetAlert styles */
.swal2-container.swal2-center > .swal2-popup {
  z-index: 10000 !important;
}

.swal2-container {
  z-index: 10000 !important;
}

.swal2-styled.swal2-confirm {
  background-color: #b49b57 !important;
  color: white !important;
  border-radius: 30px !important;
  z-index: 10000 !important;
}

.swal2-styled.swal2-cancel {
  border-radius: 30px !important;
  z-index: 10000 !important;
}

.swal2-styled.swal2-confirm:focus {
  box-shadow: 0 0 0 3px rgba(180, 155, 87, 0.3) !important;
}

/* Button hover effects */
.btn:hover:not(.btn-icon-only) {
  transform: scale(1.02) !important;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Responsive multiselect */
@media (max-width: 768px) {
  .multiselect__tags {
    min-height: 38px !important;
    padding: 5px 40px 0 8px !important;
    font-size: 0.8rem !important;
  }
  
  .multiselect__input {
    font-size: 0.8rem !important;
  }
  
  .multiselect__single {
    font-size: 0.8rem !important;
  }
}

@media (max-width: 576px) {
  .multiselect__tags {
    min-height: 36px !important;
    padding: 4px 40px 0 6px !important;
    font-size: 0.75rem !important;
  }
  
  .multiselect__input {
    font-size: 0.75rem !important;
  }
  
  .multiselect__single {
    font-size: 0.75rem !important;
  }
}

@media (max-height: 700px) {
  .multiselect__tags {
    min-height: 34px !important;
    padding: 3px 40px 0 6px !important;
    font-size: 0.7rem !important;
  }
  
  .multiselect__input {
    font-size: 0.7rem !important;
  }
  
  .multiselect__single {
    font-size: 0.7rem !important;
  }
}

.ticz-link {
  color: inherit;
  text-decoration: none;
  transition: color 0.3s ease-out;
}

.ticz-link:hover {
  background-image: linear-gradient(90deg, #b49b57, #f5e3a1);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 200% 100%;
  background-position: -100% 50%;
  animation: ticzHoverPaint 0.7s forwards;
}

@keyframes ticzHoverPaint {
  0% {
    background-position: -100% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
}
</style>
